import get from 'lodash.get';

const getSupportUrl = (rootState) =>
  get(rootState, 'user.partnerData.properties.wsSupportUrl', null);

export default getSupportUrl;
